export interface ITipoTarjeta {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  last_id: number;
  data: IDataTipoTarjeta[];
}

export interface IDataTipoTarjeta {
  id_tipotarjeta?: number;
  codigo?: string;
  nombre?: string;

  //PARAMETROS
  page_size?: number;
  page?: number;
}

export enum CreditCardType {
  AMERICANEXPRESS = "american-express",
  DINERSCLUB = "diners-club",
  DISCOVER = "discover",
  ELO = "elo",
  HIPER = "hiper",
  HIPERCARD = "hipercard",
  JCB = "jcb",
  MAESTRO = "maestro",
  MASTERCARD = "mastercard",
  MIR = "mir",
  UNIONPAY = "unionpay",
  VISA = "visa",
}